import { render, staticRenderFns } from "./BasicServiceManage.vue?vue&type=template&id=22ac586e&scoped=true"
import script from "./BasicServiceManage.vue?vue&type=script&lang=js"
export * from "./BasicServiceManage.vue?vue&type=script&lang=js"
import style0 from "./BasicServiceManage.vue?vue&type=style&index=0&id=22ac586e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac586e",
  null
  
)

export default component.exports